import { useLingui } from "@lingui/react/macro"
import React from "react"

import Button from "../../design-system/button"
import { TREMENDOUS_APP_SIGNUP } from "../../utils/urls"
import ButtonBookDemo from "../button-book-demo"
import * as styles from "./index.module.scss"

interface Props {
  location: string
  firstButtonText?: string
  secondButtonText?: string | null
}

function ButtonPair({ location, firstButtonText, secondButtonText }: Props) {
  const { t } = useLingui()
  const localizedFirstButtonLabel = firstButtonText || t`Book a demo`
  const localizedSecondButtonLabel = secondButtonText || t`Sign up now`

  return (
    <div className={styles.buttonsContainer}>
      <ButtonBookDemo
        href="/demo"
        buttonLocation={location}
        text={localizedFirstButtonLabel}
      />
      {localizedSecondButtonLabel && (
        <Button
          as="a"
          href={TREMENDOUS_APP_SIGNUP}
          trackingProperties={{
            buttonName: "Sign up now",
            buttonLocation: location,
          }}
          variant="secondary"
        >
          {localizedSecondButtonLabel}
        </Button>
      )}
    </div>
  )
}

export default ButtonPair
